const ModalLoader = () => {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="80" cy="80" r="76" stroke="#D3F1F6" strokeWidth="8" />
      <mask id="path-2-inside-1_15294_14729" fill="white">
        <path d="M156.02 80C158.218 80 160.01 78.2168 159.901 76.0213C159.418 66.3268 157.175 56.7894 153.268 47.8794C148.829 37.7528 142.338 28.6564 134.207 21.1643C126.075 13.6723 116.478 7.94725 106.022 4.35061C96.8229 1.18606 87.134 -0.270329 77.4325 0.0412068C75.2354 0.11176 73.6047 2.0439 73.7845 4.23478C73.9642 6.42565 75.8864 8.04446 78.0839 7.98599C86.6876 7.75705 95.2741 9.07159 103.433 11.8782C112.848 15.1169 121.49 20.2723 128.813 27.0188C136.135 33.7654 141.98 41.9566 145.978 51.0756C149.442 58.9778 151.454 67.428 151.93 76.0217C152.051 78.2166 153.822 80 156.02 80Z" />
      </mask>
      <g>
        <path
          d="M156.02 80C158.218 80 160.01 78.2168 159.901 76.0213C159.418 66.3268 157.175 56.7894 153.268 47.8794C148.829 37.7528 142.338 28.6564 134.207 21.1643C126.075 13.6723 116.478 7.94725 106.022 4.35061C96.8229 1.18606 87.134 -0.270329 77.4325 0.0412068C75.2354 0.11176 73.6047 2.0439 73.7845 4.23478C73.9642 6.42565 75.8864 8.04446 78.0839 7.98599C86.6876 7.75705 95.2741 9.07159 103.433 11.8782C112.848 15.1169 121.49 20.2723 128.813 27.0188C136.135 33.7654 141.98 41.9566 145.978 51.0756C149.442 58.9778 151.454 67.428 151.93 76.0217C152.051 78.2166 153.822 80 156.02 80Z"
          stroke="#5DD4E8"
          strokeWidth="16"
          mask="url(#path-2-inside-1_15294_14729)"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            from="0 80 80"
            to="360 80 80"
            dur="2.4s"
            repeatCount="indefinite"
          />
        </path>
      </g>
      <circle cx="80" cy="80" r="48" fill="#5DD4E8" />
      <rect x="60" y="76" width="8" height="24" rx="2" fill="white">
        <animate
          attributeName="opacity"
          values="0;1;1;1;0"
          keyTimes="0;0.25;0.74;0.75;1"
          dur="2.4s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="76" y="68" width="8" height="32" rx="2" fill="white">
        <animate
          attributeName="opacity"
          values="0;0;1;1;0"
          keyTimes="0;0.24;0.5;0.75;1"
          dur="2.4s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="92" y="60" width="8" height="40" rx="2" fill="white">
        <animate
          attributeName="opacity"
          values="0;0;0;1;0"
          keyTimes="0;0.49;0.5;0.75;1"
          dur="2.4s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
};

export default ModalLoader;
